//notification
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";
export const ACCOUNT_SET = "ACCOUNT_SET";
export const ACCOUNT_SELECTED = "ACCOUNT_SELECTED";
export const SAGA_GET_USER_PROFILE = "SAGA_GET_USER_PROFILE";
export const SAGA_GET_USER_PROFILE_SUCCESS = "SAGA_GET_USER_PROFILE_SUCCESS";

//AUTH
export const SAGA_SIGNUP = "SAGA_SIGNUP";
export const SAGA_SIGNUP_SUCCESS = "SAGA_SIGNUP_SUCCESS";
export const SAGA_SIGNUP_ERROR = "SAGA_SIGNUP_ERROR";

export const SAGA_LOGIN = "SAGA_LOGIN";
export const SAGA_LOGIN_SUCCESS = "SAGA_LOGIN_SUCCESS";
export const SAGA_LOGIN_ERROR = "SAGA_LOGIN_ERROR";

export const SAGA_LOGIN_INVALID = "SAGA_LOGIN_INVALID";
export const SIGNOUT = "SIGNOUT";



// WEBPACK FOOTER //
// ./src/constants/index.js